import { render, staticRenderFns } from "./sbInfo.vue?vue&type=template&id=fb79bbaa&scoped=true"
import script from "./sbInfo.vue?vue&type=script&lang=js"
export * from "./sbInfo.vue?vue&type=script&lang=js"
import style0 from "./sbInfo.vue?vue&type=style&index=0&id=fb79bbaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb79bbaa",
  null
  
)

export default component.exports